import defaultTheme from "../styles/themes/default.module.scss"

type ThemeVariables = {
  backgroundPrimary: string
  backgroundSecondary: string
  backgroundTertiary: string
  backgroundQuaternary: string
  backgroundAdditional: string
  backgroundError: string
  backgroundDiscount: string
  backgroundDarkGreen: string
  backgroundWarning: string

  textPrimary: string
  textSecondary: string
  textTertiary: string
  textQuaternary: string
  textInviteB: string
  textError: string
  textBlueAccent: string
  textLightBlueAccent: string
  textCommunityBlue: string
  textGreenAccent: string
  textWarningLight: string
  textApproved: string
  textPending: string
  textRejected: string
  textWarning: string

  buttonPrimaryDefault: string
  buttonPrimaryHover: string
  buttonPrimaryActive: string
  buttonPrimaryDisabled: string
  buttonSecondaryDefault: string
  buttonSecondaryHover: string
  buttonSecondaryActive: string
  buttonSecondaryDisabled: string
  buttonGradient: string
  buttonGreenDefault: string
  buttonGreenHover: string
  buttonGreenActive: string
  buttonGreenDisabled: string
  buttonTertiaryDefault: string
  buttonTertiaryHover: string
  buttonTertiaryActive: string
  buttonTertiaryDisabled: string
  buttonErrorDefault: string
  buttonErrorHover: string
  buttonErrorActive: string
  buttonErrorDisabled: string
  buttonBadgeDarkBlueDefault: string
  buttonBadgeDarkBlueHover: string
  buttonBadgeDarkBlueActive: string
  buttonDarkGreenDefault: string
  buttonDarkGreenHover: string
  buttonDarkGreenActive: string
  buttonDarkGreenDisabled: string
  buttonOutlineSecondaryDefault: string
  buttonOutlineSecondaryHover: string
  buttonOutlineSecondaryActive: string
  buttonOutlineSecondaryDisabled: string

  iconPrimary: string
  iconSecondary: string
  iconTertiary: string
  iconQuaternary: string
  iconThumbsUp: string
  iconInviteB: string
  iconError: string
  iconBlueAccent: string
  iconGreenAccent: string
  iconSuccess: string

  strokePrimary: string
  strokeSecondary: string
  strokeTertiary: string
  strokeQuaternary: string
  strokeInput: string
  strokeInputLight: string
  strokeScroller: string
  strokeMessagesInput: string
  strokeBlueAccent: string
  strokeLightBlueAccent: string
  strokeGreenAccent: string

  tagsGreenBackground: string
  tagsGreenText: string
  tagsBlueBackground: string
  tagsWarningBackground: string
  tagsWarningText: string
  tagsSuccessBackground: string
  tagsSuccessText: string
  tagsErrorBackground: string
  tagsErrorText: string
  tagsAgentPickBackground: string
  tagsAgentPickText: string

  bannerWarning: string
  bannerError: string

  pureWhite: string
  pureBlack: string
  modalOverlay: string
  downloadAppBannerBackground: string

  cardGradient: string
  transparentGradientBackground: string
  tooltipShadow: string
  unreadMessageBadge: string
}

export const colors = defaultTheme as ThemeVariables
